import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import { MenuContainer } from "../../components/menuContainer/MenuContainer";

const GalleryContainer = styled.div`
  padding: 5rem;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const ImageContainer = styled.div`
  position: relative;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.9;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Modal = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

const ModalContent = styled.div`
  position: relative;
  max-width: 80vw;
  max-height: 80vh;
  margin: 0 1rem;
`;

const ModalImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const CloseButton = styled.button`
  border: 0px;
  position: absolute;
  top: -0.5rem;
  right: -2rem;
  color: #fff;
  background: rgba(0, 0, 0, 0);
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0);
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
`;

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = Array.from({ length: 23 }, (_, i) => ({
    id: i + 1,
    src: `/gallery/gallery_${i + 1}.jpg`,
  }));

  // 수정된 부분: setSelectedImageAndIndex 함수 추가
  const setSelectedImageAndIndex = (image) => {
    const index = images.findIndex((img) => img.id === image.id);
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  // 수정된 부분: moveImage 함수 수정
  const moveImage = (direction) => {
    let newIndex;
    if (direction === "next") {
      newIndex = (currentIndex + 1) % images.length;
    } else if (direction === "prev") {
      newIndex = (currentIndex - 1 + images.length) % images.length;
    }
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  const handleKeyDown = (event) => {
    if (event.key === "ArrowRight") {
      moveImage("next");
    } else if (event.key === "ArrowLeft") {
      moveImage("prev");
    }
  };

  useEffect(() => {
    if (selectedImage) {
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [selectedImage]);

  return (
    <div>
      <MenuContainer
        title="갤러리"
        menu="갤러리"
        pointRadius="50%"
      ></MenuContainer>
      <GalleryContainer>
        <GalleryGrid>
          {images.map((image) => (
            <ImageContainer
              key={image.id}
              // 수정된 부분: onClick 이벤트 핸들러 변경
              onClick={() => setSelectedImageAndIndex(image)}
            >
              <Image src={image.src} alt={`Gallery ${image.id}`} />
            </ImageContainer>
          ))}
        </GalleryGrid>

        {selectedImage && (
          <Modal onClick={() => setSelectedImage(null)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setSelectedImage(null)}>
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </CloseButton>
              <ArrowButton
                onClick={() => moveImage("prev")}
                style={{ left: "-3rem" }}
              >
                <svg
                  width="19"
                  height="30"
                  viewBox="0 0 19 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5469 3.04688C14.2293 3.57343 7.09643 11.1677 3.6945 14.8992L15.5469 26.7516"
                    stroke="white"
                    strokeWidth="5"
                    strokeLinecap="round"
                  />
                </svg>
              </ArrowButton>
              <ModalImage
                // 수정된 부분: src와 alt 속성 변경
                src={selectedImage.src}
                alt={`Gallery ${selectedImage.id}`}
              />
              <ArrowButton
                onClick={() => moveImage("next")}
                style={{ right: "-3rem" }}
              >
                <svg
                  width="19"
                  height="30"
                  viewBox="0 0 19 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.875 3.04688C4.19253 3.57343 11.3254 11.1677 14.7274 14.8992L2.875 26.7516"
                    stroke="white"
                    strokeWidth="5"
                    strokeLinecap="round"
                  />
                </svg>
              </ArrowButton>
            </ModalContent>
          </Modal>
        )}
      </GalleryContainer>
    </div>
  );
};
